import { useContext } from "react";
import { ImageContext } from "@components";
import classNames from "classnames";

import type { RenderOptionProps as TilesOptionProps } from "../../../../components/Tiles/TilesV2";
import type { MergedOptionValue } from "../../../services/util/optionRendering";

export default function TilesGraphicOptionV2<T extends MergedOptionValue>({
  disabled,
  image,
  isActive,
  label,
  value,
}: T & TilesOptionProps) {
  const ImageElement = useContext(ImageContext);
  const borderClasses = classNames(
    "rounded-sm",
    isActive ? "border-charcoal" : "border-transparent"
  );

  return (
    <div className="flex flex-col items-center">
      <div
        className={classNames(
          "inline-block border lg:border-0",
          borderClasses,
          {
            "cursor-default": disabled,
            "cursor-pointer": !disabled,
          }
        )}
      >
        {image && (
          <div
            className={classNames(
              "p-3 lg:border leading-[0] lg:mb-2",
              borderClasses
            )}
          >
            <ImageElement
              src={image.src}
              alt={value}
              height={image.height}
              width={image.width}
              className="rounded-t-sm lg:rounded-sm"
            />
          </div>
        )}
        <p
          className={classNames(
            "w-full relative leading-tight px-0.5",
            "py-2.5 lg:py-0 text-xs text-center"
          )}
        >
          {label || value}
        </p>
      </div>
    </div>
  );
}
